import { all } from 'redux-saga/effects'

import { sagas as connectionList } from '~/ducks/connection/list'
import { sagas as messageList } from '~/ducks/message/list'
import { sagas as taskInstanceList } from '~/ducks/taskInstance/list'

export default function* rootSaga() {
  yield all([...messageList, ...connectionList, ...taskInstanceList])
}
